/** @format */
import { css } from 'styled-components';

import { BaseTabProps } from './index';

/**
 * Base styles for the desktop main nav component
 */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    padding: var(--layout-spacing-24) var(--layout-spacing-48) 12rem
        var(--layout-spacing-48);

    .original-content-nav-item-title {
        display: inline-block;
    }

    .see-all-original-content-link {
        display: inline-block;
        margin-top: var(--layout-spacing-48);
    }

    .menu-tabs {
        margin-bottom: var(--layout-spacing-48);
    }

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    // gradient for bottom of menu
    &:after {
        content: '';
        position: absolute;
        height: 12rem;
        width: calc(100% - 8.8rem);
        transform: translateX(-50%);
        bottom: 0;
        left: 50%;
        pointer-events: none;
        background: linear-gradient(
            180deg,
            transparent 0%,
            rgba(255, 255, 255, 0.69) 25%,
            #ffffff 100%
        );
    }

    .browse-all-link {
        margin-top: var(--layout-spacing-16);
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

export const baseTabStyles = ({ isActive }: BaseTabProps) => css`
    display: ${isActive ? 'block' : 'none'};
`;

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
export const categoryTabStyles = css`
    .columns {
        li {
            &:nth-of-type(1) {
                -ms-grid-column: 1;
            }

            &:nth-of-type(2) {
                -ms-grid-column: 2;
            }
        }

        .category-tree[data-depth='0'] {
            margin-bottom: var(--layout-spacing-24);

            .category > a {
                margin-bottom: var(--layout-spacing-24);
                display: inline-block;
            }

            > .category {
                column-count: 2;

                > a {
                    column-span: all;
                }

                > .category-tree {
                    break-inside: avoid;
                }
            }
        }

        .category-tree[data-depth='1'] {
            margin-bottom: var(--layout-spacing-12);

            .category > a {
                margin-bottom: var(--layout-spacing-12);
                font-weight: 400;
                display: inline-block;
            }
        }

        .category-tree[data-depth='2'] {
            &:last-of-type {
                margin-bottom: var(--layout-spacing-24);
            }

            .category > a {
                margin-bottom: 0.8rem;
                font-weight: 300;
                display: inline-block;
            }
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The desktop main nav component styles
 */
export const styles = css`
    ${baseStyles}
`;
